import React, {FC} from "react"
import Styles from "./index.less"
import Json from "./result.json"

const JsonToTable: FC<any> = (props) => {
    const tableData = props.data
    let tableRowSpan = new Map()
    const renderTable = () => {
        return (
            <table className={Styles.tableStyle}>
                <tbody>
                    {tableData.cell.map((tableItem: any, index: number) => {
                        return [
                            <tr key={`tr${index + 1}`}>
                                {tableItem.map((tableItem: any, index: number) => {
                                    if (tableItem.endRow !== tableItem.startRow) {
                                        if (!tableRowSpan.get(`${tableItem.startCol},${tableItem.startRow}`)) {
                                            tableRowSpan.set(`${tableItem.startCol},${tableItem.startRow}`, tableItem)
                                            return (
                                                <td
                                                    rowSpan={tableItem.endRow - tableItem.startRow + 1}
                                                    colSpan={tableItem.endCol - tableItem.startCol + 1}
                                                    key={`td${index + 1}`}
                                                >
                                                    {tableItem.text}
                                                </td>
                                            )
                                        }
                                    } else {
                                        return (
                                            <td
                                                colSpan={tableItem.endCol - tableItem.startCol + 1}
                                                key={`td${index + 1}`}
                                            >
                                                {tableItem.text}
                                            </td>
                                        )
                                    }
                                })}
                            </tr>,
                        ]
                    })}
                </tbody>
            </table>
        )
    }
    return renderTable()
}
export default JsonToTable
